<div class="w-full flex relative select-none">

  <div id="pdfContent" class="mx-auto rounded pdf-only" style="width:794px; background:#fff !important;">
    <!-- Cover Page -->
    <div class="relative" style="background:#ffffff;">
      <div class="carbon-main py-3 px-5 bg-white">
        <div class="h-fit w-full object-contain flex items-center justify-center carbon-img">
          <img id="banner" [src]="imagesBaseUrl + '/logo_carbon_new.png'"
            class="object-contain !max-w-[190px] !w-[190px] !h-[108px]" />
        </div>
        <div class="p-5">
          <h1 class="pt-2" style="color:#000000; font-size: 34px;">Carbon Footprint <br> Assessment of the Report</h1>
          <img class="w-[120px] object-contain rounded-full mt-[50px]" [src]="currentLogo" alt="Company Logo">
        </div>
      </div>
      <img id="cover-main-image" [src]="imagesBaseUrl + '/pdf_main_image.png'" class="bg-white w-[100%] object-contain"
        style="height: 500px;" />
      <img id="banner" [src]="imagesBaseUrl + '/carbon-second-image-new.png'"
        class="bg-white w-[67px] h-[57px] max-w-3xl object-contain main-image" />
    </div>

    <div class="pbk"></div>

    <!-- Index Page -->
    <div class="p-1 pt-5 pb-10 relative" style="background:#ffffff;">
      <!-- Page header logo - top right corner -->
      <!-- <img src="https://cfprobeta.foreverbambu.me/images/carbon-second-image-new.png" style="position:absolute; top:15px; right:15px; width:67px; height:57px;" /> -->
      <!-- Page footer logo - bottom left corner -->
      <!-- <img src="https://cfprobeta.foreverbambu.me/images/carbon-bottom-new.png" style="position:absolute; bottom:15px; left:15px; width:80px;" /> -->

      <div class="index-wrapper">
        <div class="section-title-container" style="margin-bottom: 10px;">
          <div class="section-title-line"></div>
          <span class="futura section-title-text">{{ locale.report.index }}</span>
          <div class="section-title-line"></div>
        </div>

        <div class="flex flex-col sm:flex-row w-full gap-3 sm:gap-0 mt-5">
          <!-- LEFT -->
          <div class="w-full sm:w-1/2 px-3 text-left">
            <h3 style="color:#1a472a;">1. {{ locale.report.methodological_approach }}</h3>
            <h3 style="color:#1a472a;">2. {{ locale.report.introduction }}</h3>
            <h3 style="color:#1a472a;">3. {{ locale.report.company_profile }}</h3>
            <ul style="color:#4a5568;">
              <li>3.1. {{ locale.report.mission }}</li>
              <li>3.2. {{ locale.report.vision }}</li>
            </ul>
            <h3 style="color:#1a472a;">4. {{ locale.report.purpose_scope }}</h3>
            <h3 style="color:#1a472a;">5. {{ locale.report.regulatory_references }}</h3>
            <h3 style="color:#1a472a;">6. {{ locale.report.ghg_boundaries }}</h3>
            <ul style="color:#4a5568;">
              <li>6.1. {{ locale.report.organizational_boundaries }}</li>
              <li>6.2. {{ locale.report.reporting_boundaries }}</li>
              <li>6.3. {{ locale.report.categorization }}</li>
              <li>6.4. {{ locale.report.principles_adopted }}</li>
              <li>6.5. {{ locale.report.reporting_phases }}</li>
              <li>6.6. {{ locale.report.significance_definition }}</li>
            </ul>
          </div>

          <!-- RIGHT -->
          <div class="w-full sm:w-1/2 px-3 text-left">
            <h3 style="color:#1a472a;">7. {{ locale.report.ghg_quantification }}</h3>
            <ul style="color:#4a5568;">
              <li>7.1. {{ locale.report.quantification_approach }}</li>
              <li>7.2. {{ locale.report.topics_reported }}</li>
              <li>7.3. {{ locale.report.category_1 }}</li>
              <li>7.4. {{ locale.report.category_2 }}</li>
              <li>7.5. {{ locale.report.category_3 }}</li>
              <li>7.6. {{ locale.report.category_4 }}</li>
              <li>7.7. {{ locale.report.category_5 }}</li>
              <li>7.8. {{ locale.report.category_6 }}</li>
              <li>7.9. {{ locale.report.total_emissions }}</li>
            </ul>
            <h3 style="color:#1a472a;">8. {{ locale.report.results_comment }}</h3>
            <h3 style="color:#1a472a;">9. {{ locale.report.uncertainty_evaluation }}</h3>
            <h3 style="color:#1a472a;">10. {{ locale.report.emission_reduction }}</h3>
            <h3 style="color:#1a472a;">11. {{ locale.report.quality_management }}</h3>
            <h3 style="color:#1a472a;">12. {{ locale.report.verification_role }}</h3>
            <ul style="color:#4a5568;">
              <li>12.1. {{ locale.report.reduction_activities }}</li>
              <li>12.2. {{ locale.report.carbon_offsetting }}</li>
            </ul>
            <h3 style="color:#1a472a;">13. {{ locale.report.glossary }}</h3>
          </div>
        </div>
      </div>
    </div>

    <!-- Section Pages -->
    <div *ngFor="let section of sections" class="section-wrapper relative">
      <!-- Page header logo - top right corner -->
      <!-- <img src="https://cfprobeta.foreverbambu.me/images/carbon-second-image-new.png" style="position:absolute; top:15px; right:15px; width:67px; height:57px;" /> -->
      <!-- Page footer logo - bottom left corner -->
      <!-- <img src="https://cfprobeta.foreverbambu.me/images/carbon-bottom-new.png" style="position:absolute; bottom:15px; left:15px; width:80px;" /> -->

      <!-- Section content -->
      <div style="background:#ffffff;">
        <div class="section-title-container" style="margin-bottom: 10px;">
          <div class="section-title-line"></div>
          <span class="futura section-title-text">{{ section.title.replace('*', '').trim() }}</span>
          <div class="section-title-line"></div>
        </div>

        <ng-container *ngFor="let block of section.blocks">
          <p *ngIf="block.type === 'p'" class="section-paragraph {{block.currentClass}}"
            style="color:#333333; {{block.currentStyle}}" [innerHTML]="block.text">
          </p>

          <h1 *ngIf="block.type === 'heading' && block.level === 1" class="subsection-title {{block.currentClass}}"
            style="color:#043B22; font-size:24px; font-weight:700; {{block.currentStyle}}" [innerHTML]="block.text">
          </h1>
          <h2 *ngIf="block.type === 'heading' && block.level === 2" class=" {{block.currentClass}}"
            style="color:#043B22; font-size:20px; font-weight:600; {{block.currentStyle}}" [innerHTML]="block.text">
          </h2>
          <h3 *ngIf="block.type === 'heading' && block.level === 3" class=" {{block.currentClass}}"
            style="color:#043B22; font-size:18px; font-weight:600; {{block.currentStyle}}" [innerHTML]="block.text">
          </h3>
          <h4 *ngIf="block.type === 'heading' && block.level === 4" class=" {{block.currentClass}}"
            style="color:#043B22; font-size:16px; font-weight:600; {{block.currentStyle}}" [innerHTML]="block.text">
          </h4>
          <h5 *ngIf="block.type === 'heading' && block.level === 5" class=" {{block.currentClass}}"
            style="color:#043B22; font-size:14px; font-weight:600; {{block.currentStyle}}" [innerHTML]="block.text">
          </h5>
          <h6 *ngIf="block.type === 'heading' && block.level === 6" class=" {{block.currentClass}}"
            style="color:#043B22; font-size:12px; font-weight:600; {{block.currentStyle}}" [innerHTML]="block.text">
          </h6>

          <table *ngIf="block.type === 'table'" class="w-full mb-4 {{block.currentClass}}"
            style="{{block.currentStyle}}">
            <thead>
              <tr>
                <th *ngFor="let h of block.headers" style="{{h.style}}">
                  {{ h.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of block.rows">
                <td *ngFor="let cell of row">
                  {{ cell }}
                </td>
              </tr>
            </tbody>
          </table>

          <div *ngIf="block.type === 'ul'" class="pdf-list {{block.currentClass}}"
            style="margin: 15px 0; color:#333333; {{block.currentStyle}}">
            <div *ngFor="let item of block.items"
              style="display: flex; font-size:13px; align-items: flex-start; margin-bottom: 6px; line-height: 1.6;">
              <span style="margin-right: 8px; flex-shrink: 0;">•</span>
              <span [innerHTML]="item"></span>
            </div>
          </div>

          <div *ngIf="block.type === 'ol'" class="pdf-list {{block.currentClass}}"
            style="margin: 15px 0; color:#333333; {{block.currentStyle}}">
            <div *ngFor="let item of block.items; let i = index"
              style="display: flex; font-size:13px; align-items: flex-start; margin-bottom: 6px; line-height: 1.6;">
              <span style="flex-shrink: 0; min-width: 18px;">{{i + 1}}.</span>
              <span [innerHTML]="item"></span>
            </div>
          </div>

          <img *ngIf="block.type === 'img'" [src]="block.src" [alt]="block.alt" class="{{block.currentClass}}"
            style="max-width: 100%; height: auto; margin: 10px 0; {{block.currentStyle}}">
        </ng-container>
      </div>
    </div>
  </div>
</div>